import { useSiteSettings } from "@/context/SiteSettingsContext";
import { Info } from "lucide-react";
import WaitlistForm from "@/components/WaitlistForm";

export default function PrelaunchBanner() {
  const { isPrelaunch, settings } = useSiteSettings();
  if (!isPrelaunch) return null;
  return (
    <>
      <div data-testid="prelaunch-banner"
        className="bg-yellow-500/10 border-b border-yellow-500/30 text-yellow-200/95">
        <div className="container-tight py-3 flex items-start gap-3">
          <Info className="w-4 h-4 mt-0.5 flex-shrink-0 text-yellow-400" />
          <div className="text-sm">
            <div className="font-display font-semibold text-yellow-100">
              {settings.prelaunch_headline || "Interstate PC is preparing our online catalog for launch."}
            </div>
            <div className="text-xs text-yellow-200/80 mt-0.5 leading-relaxed">
              {(() => {
                const msg = settings.prelaunch_message || "Our product catalog and online ordering are being prepared. Please contact sales@interstate-pc.com for business or product inquiries.";
                const email = "sales@interstate-pc.com";
                const idx = msg.indexOf(email);
                if (idx === -1) return msg;
                return (
                  <>
                    {msg.slice(0, idx)}
                    <a href={`mailto:${email}`} className="underline text-yellow-100 hover:text-white">
                      {email}
                    </a>
                    {msg.slice(idx + email.length)}
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      </div>
      <div className="border-b border-zinc-900 bg-[#050505]" data-testid="prelaunch-waitlist-section">
        <div className="container-tight py-6">
          <WaitlistForm />
        </div>
      </div>
    </>
  );
}
